export { IdDiamondCar1 } from "./IdDiamondCar1";
